<template>
  <div
    class="flex flex-col h-screen w-screen overflow-hidden justify-center align-middle items-center papsi-bg">
      
    <div class="flex flex-row justify-center align-center items-center absolute mt-16" style="gap: 1rem; top: 0;">
        <img class="logo" style="width: 7rem;" src="https://resource.pafcpic.net/assets/ga/papsi_icon.png" />
        <img class="logo shadow-lg" style="width: 10rem;" :src="getImage('pia-4')" />
    </div>


    <!-- <img class="absolute pt-5 w-1/6 mt-16" :src="getImage('logo')" style="top: 0;" /> -->
    <div @click="this.goBack()" style="top: 5rem; left: 5rem;" class="absolute shadow-md bg-primary h-16 w-16 rounded-xl flex justify-center align-middle items-center text-3xl text-grey-darker font-semibold">
          <img :src="getIcon('back_white')" alt="">
    </div>

    <div class="flex flex-col justify-center align-middle items-center z-20 mb-16 mt-24 text-6xl uppercase">
      <p class="text-white text-5xl">Select your</p>
      <p class="font-bold text-primary-light text-7xl">Language</p>
    </div>
    
    <div class="flex flex-row justify-center align-middle items-center text-grey-darker font-semibold uppercase" style="gap: 3rem;">
      <div
        @click="setLanguage('en')"
        class="flex flex-col justify-center items-center align-middle px-32 py-16 bg-grey-lightest rounded-xl"
      >
        <img :src="getImage('english')" class="w-32 h-32"/>
        <p class="text-5xl mt-6">English</p>
      </div>

      <div
        @click="setLanguage('tl')"
        class="flex flex-col justify-center items-center align-middle px-32 py-16 bg-grey-lightest rounded-xl"
      >
        <img :src="getImage('tagalog')" class="w-32 h-32"/>
        <p class="text-5xl mt-6">Filipino</p>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "@/mixins/controls.js";

export default {
  mixins: [mixin],
  components: {},
  data() {
    return {
      inactivity_timeout: null,
    };
  },
  methods: {
    setLanguage(lang) {
      this.$store.commit('setLanguage', lang); 
      this.$i18n.locale = lang; // Set the locale directly
      this.$router.push({ name: "login-page" }); 
    },
    resetInactivityTimer() {
      clearTimeout(this.inactivity_timeout);
      this.startInactivityTimer();
    },
    startInactivityTimer() {
      if (process.env.VUE_APP_DEVELOPMENT_MODE === 'false') {
        this.inactivity_timeout = setTimeout(() => {
        this.$router.push({ name: "start-page" });
        }, process.env.VUE_APP_IDLE_DELAY || 30000);
      } 
    },
  },
  mounted() {
    this.$emit('checkauth', false);
    this.startInactivityTimer();
    window.addEventListener('touchstart', this.resetInactivityTimer);
  },
  beforeUnmount() {
    clearTimeout(this.inactivity_timeout);
    window.removeEventListener('touchstart', this.resetInactivityTimer);
  },
};
</script>

<style scoped>
.papsi-bg {
  /* background-image: url('https://resource.pafcpic.net/assets/pia/images/elements/papsi_background.webp'); */
  /* background-image: url('@/assets/images/papsi-lang-bg.png'); */
  background-image: url('https://resource.pafcpic.net/assets/pia/images/elements/papsi-lang-bg.png');
  background-size: cover;
}
</style>